import { useTranslation } from "react-i18next";

import { ApiError } from "@/lib/api-client";
import { useCanEditMarketplaceOrderFulfillment } from "@/features/marketplace/admin/hooks/useCanEditMarketplaceOrderFulfillment";
import { useMarketplaceOrderScriptByReview } from "@/lib/queries";

import { SendPartnerRevisionPanel } from "./SendPartnerRevisionPanel";

interface ScriptReviewPartnerRevisionSectionProps {
  scriptReviewId: string;
  enabled: boolean;
}

export function ScriptReviewPartnerRevisionSection({
  scriptReviewId,
  enabled,
}: ScriptReviewPartnerRevisionSectionProps) {
  const { t } = useTranslation();
  const canSendPartnerRevision = useCanEditMarketplaceOrderFulfillment();
  const marketplaceLinkQuery = useMarketplaceOrderScriptByReview(
    scriptReviewId,
    enabled && canSendPartnerRevision,
  );

  if (!enabled || !canSendPartnerRevision) {
    return null;
  }

  if (marketplaceLinkQuery.isLoading) {
    return (
      <p className="text-xs text-muted-foreground">
        {t("scriptReview.partnerRevision.loading", "Loading partner order link…")}
      </p>
    );
  }

  if (marketplaceLinkQuery.isError) {
    if (marketplaceLinkQuery.error instanceof ApiError && marketplaceLinkQuery.error.status === 404) {
      return null;
    }
    return (
      <p className="rounded-md border border-destructive/30 bg-destructive/5 p-3 text-xs text-destructive">
        {t(
          "scriptReview.partnerRevision.loadError",
          "Could not load the linked production order. Refresh the page or try again.",
        )}
      </p>
    );
  }

  if (!marketplaceLinkQuery.data) {
    return null;
  }

  return (
    <SendPartnerRevisionPanel scriptReviewId={scriptReviewId} link={marketplaceLinkQuery.data} />
  );
}
